import api from "../../services/api";
import {
  MOCK_COHORT_PREVIEWS,
  MOCK_EXPORT_CSV
} from "../../config/mockResponses";

export default function Export() {

  const downloadCSV = (content, filename) => {
    const blob = new Blob([content], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const exportCohort = async (cohort) => {
    try {
      const res = await api.get(
        `https://aihealth.ascendeongroup.com/api-dev/v1/admin/cohorts/${cohort.segment_id}/export.csv`,
        {
          headers: {
            accept: "application/json"
          },
          responseType: "text"
        }
      );

      downloadCSV(
        res.data,
        `${cohort.cohort_name.replace(/\s+/g, "_")}.csv`
      );

    } catch (err) {
      console.warn("Export API failed, using mock CSV", err);

      downloadCSV(
        MOCK_EXPORT_CSV,
        `${cohort.cohort_name.replace(/\s+/g, "_")}_mock.csv`
      );
    }
  };

  return (
    <div className="content">
      <h2>Export</h2>

      <table className="data-table">
        <thead>
          <tr>
            <th>Cohort Name</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {MOCK_COHORT_PREVIEWS.map(cohort => (
            <tr key={cohort.segment_id}>
              <td>{cohort.cohort_name}</td>
              <td>
                <button
                  onClick={() => exportCohort(cohort)}
                >
                  Export
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
